import {SiteStore} from '@wix/wixstores-client-core/dist/es/src/viewer-script/site-store/siteStore';
import {WishlistApi} from '../api/WishlistApi';
import {IAppSettings, IProduct} from '../types/app-types';
import {WishlistActions} from '@wix/wixstores-client-storefront-sdk/dist/es/src/wishlist-actions/WishlistActions';
import md5 from 'md5';

export class WishlistService {
  private products?: IProduct[];
  private readonly api: WishlistApi;
  private fetches: number = 0;
  private totalProducts: number = 1;

  constructor(private readonly siteStore: SiteStore, private readonly externalId: string) {
    this.api = new WishlistApi(this.siteStore);
  }

  private getHeaders() {
    return {
      Authorization: (this.siteStore.httpClient.getBaseHeaders() as any).Authorization,
    };
  }

  public isLoaded(): boolean {
    return !!this.products;
  }

  public async getProducts(limit: number, offset: number): Promise<IProduct[]> {
    const data = await this.api.fetchProducts(limit, offset);
    this.products = data.products;
    this.totalProducts = data.totalCount;
    this.fetches++;

    return this.products;
  }

  public async removeProduct(productId: string): Promise<void> {
    await new WishlistActions(this.getHeaders()).removeProducts([productId]);
  }

  public async getAppSettings(): Promise<IAppSettings> {
    return this.api.fetchAppSettings(this.externalId);
  }

  public signature(): string {
    return md5(String(this.fetches) + JSON.stringify(this.products));
  }

  public getTotalProducts(): number {
    return this.totalProducts;
  }
}
